import { SagaIterator } from "redux-saga";
import { select } from "redux-saga/effects";

import { ReportDistribution } from "constants/reports/distribution";
import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { Plan, selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { IActionWithPayload } from "store/helper";

import { IFetchReportPayload } from "../interfaces";

import { makeFetchingSaga } from "./helpers";

export function* fetchHandlingTimeByStatus(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  action.payload.distribution = ReportDistribution.Day; // force day distribution -- there's no 24h distribution for handling time by status
  const isTeam = yield select(state => selectCurrentSubscriptionPlan(state) === Plan.Team);

  let requests = [
    {
      name: "handlingTimeByStatus",
      interface: ApiManager.reportApi.fetchHandlingTimeByStatus,
    },
    {
      name: "handlingTimeByStatusTotal",
      interface: ApiManager.reportApi.fetchHandlingTimeByStatusTotal,
    },
    {
      name: "handlingTimeByStatusPerTeam",
      interface: ApiManager.reportApi.fetchHandlingTimePerTeam,
    },
  ];

  if (!isTeam) {
    requests = [
      ...requests,
      {
        name: "handlingTimeByStatusPerAgent",
        interface: ApiManager.reportApi.fetchHandlingTimePerAgent,
      },
    ];
  }
  // @ts-expect-error TS(2345): Argument of type '{ name: string; interface: any; ... Remove this comment to see the full error message
  yield makeFetchingSaga(ReportType.HandlingTimeByStatus, action, requests);
}
